export default "<p>\n  success-snack-bar works!\n</p>\n";